<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaUsers"
        sort-name="cargo"
        title-table="Diretoria"
        module="diretoriaSettingsModule"
        add-permission="ROLE_DIRETORIA_INSERIR"
        view-permission="ROLE_DIRETORIA_CONSULTAR"
        edit-permission="ROLE_DIRETORIA_ATUALIZAR"
        delete-permission="ROLE_DIRETORIA_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <form-diretoria v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import FormDiretoria from "./forms/Form.vue";

export default {
  name: "Users",
  components: {
    BRow,
    BCol,
    TableComponents,
    FormDiretoria,
  },
  computed: {
    ...mapState("diretoriaSettingsModule", {
      listaUsers: (state) => state.listaUsers,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: this.$t("id"),
          field: "id",
        },
        {
          label: "Nome",
          field: "firstName",
        },
        {
          label: "Sobre Nome",
          field: "lastName",
        },
        {
          label: "email",
          field: "email",
        },
        {
          label: this.$t("Action"),
          field: "action",
        },
      ],
    };
  },
  methods: {
    addNew() {
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch("diretoriaSettingsModule/prepareToEditUser", data);
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
    },
  },
};
</script>
